import { Grid, Paper } from '@mui/material';
import { useSnackbar } from 'notistack';
import { SubmitHandler } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router';
import * as api from '../../api/app/groupApi';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { PageHeader } from '../../components/core/PageHeader/PageHeader';
import { useTranslation } from '../../contexts/translation';
import { GroupInput } from '../../types/app/group.types';
import { convertDataFromInputToCreateRequest } from '../../utils/core/functions/group.functions';
import { paths } from '../../utils/core/routes';
import { GroupForm } from './GroupForm';
import { useStyles } from './GroupForm.styles';

export function GroupCreate() {
  const { t } = useTranslation();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { mutate: mutateCreateGroup } = useMutation(api.createGroup);

  const handleOnSubmit: SubmitHandler<GroupInput> = (data: GroupInput) => {
    const requestData = convertDataFromInputToCreateRequest({
      ...data,
    });

    mutateCreateGroup(
      { ...requestData },
      {
        onSuccess: () => {
          enqueueSnackbar(t('page.group.item-created'), { variant: 'success' });
          navigate(paths.GROUP_LIST);
        },
        onError: (result: any) => {
          enqueueSnackbar(`${result}`, { variant: 'error' });
        },
      },
    );
  };

  return (
    <>
      <PageHeader title={t('page.group.headline-create')} />
      <PageContent>
        <Grid container spacing={1}>
          <Grid item xs={12} md={8} lg={4}>
            <Paper className={classes.paper}>
              <GroupForm onSubmit={handleOnSubmit} onBack={() => navigate(paths.GROUP_LIST)} />
            </Paper>
          </Grid>
        </Grid>
      </PageContent>
    </>
  );
}
